module.exports = __webpack_public_path__ + "img/tron (11).01d31801.jpg";